// extracted by mini-css-extract-plugin
export default {"subheader":"wRIoqfA3vuef124mtZdu","entitiesCounter":"d6vVgohDAYjUj6w5OHkX","table":"ChwewguHOybsIHAKRY1H","searchInput":"ZanqljTxfuwKXlZUEfsA","noRowsIcon":"zePWkblG6gSl8sakZG8X"};